import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';
import type { PresenceMotionSlotProps } from '@fluentui/react-motion';

export type AnimatedPlaceholderSlots = {
  root: NonNullable<Slot<'div'>>;
  motion: NonNullable<Slot<PresenceMotionSlotProps>>;
  placeholder: NonNullable<Slot<'div'>>;
};

/**
 * AnimatedPlaceholder Props
 */
export type AnimatedPlaceholderProps = ComponentProps<Partial<AnimatedPlaceholderSlots>> & {
  /**
   * The placeholder value to animate.
   */
  placeholderValue: string;
};

/**
 * State used in rendering AnimatedPlaceholder
 */
export type AnimatedPlaceholderState = ComponentState<AnimatedPlaceholderSlots>;
